import { render, staticRenderFns } from "./appMg.vue?vue&type=template&id=5da85112&scoped=true&"
import script from "./appMg.vue?vue&type=script&lang=js&"
export * from "./appMg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da85112",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5da85112')) {
      api.createRecord('5da85112', component.options)
    } else {
      api.reload('5da85112', component.options)
    }
    module.hot.accept("./appMg.vue?vue&type=template&id=5da85112&scoped=true&", function () {
      api.rerender('5da85112', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/configuration/appMg.vue"
export default component.exports